
























































import axios from "axios";
import DocumentosFirmadosSimple from '@/components/DocumentosFirmadosSimple.vue'; 

export default {
  components: { DocumentosFirmadosSimple },
  data: function() {
    return {
      llaveActual: null,
      documentos: [],
      estadolote: "",
      item_totales: 0,
      indicador:"cargando...",
      dialogo_rechazo:false,
      id_actual: 0,
      lote_actual: 0,
      boton_etiqueta:"Rechazar",
      boton_disabled:true,
      descripcion_guardar:"",
      descripcion:"",
      elementos:0,
      sortBy: 'id',
        sortDesc: "desc",
      fileName: "",
    };
  },
  
  computed: {

  },
  created () {
    this.lote_actual = this.$route.params.lote;
    if(this.$store.state.optionsTable.sortBy.length > 0) {
      this.sortDesc = this.$store.state.optionsTable.sortDesc[0]?"desc":"asc";
      this.sortBy = this.$store.state.optionsTable.sortBy[0];
    }
    this.LoteDetalle(this.$route.params.id);
  },
  mounted() {
     
  },
  methods: {
    LoteDetalle(id_buscar) {
      let turl = 'Lotes/listar_detalle_lote_paginacion?lote_id='+this.lote_actual+'&page=0&per_page=0&sortBy='+this.sortBy+'&direction='+this.sortDesc;
      let getdoc = axios.get(turl, { 'headers': this.$store.state.user.headers })
      return getdoc.then(res => {
        //console.log(res);
        this.documentos = res.data.items;
        this.item_totales = res.data.total;
        this.llaveActual = this.documentos.findIndex(e => e.id == id_buscar);
        this.seleccionaDocumento(0);
      })
      .catch(err => { 
          if (err.response) { console.log(err.response.data + " " +err.response.status)  } 
          else if (err.request) { console.log(err.request)  } 
          else  { console.log(err.message )}        
      })
      .finally(() => this.loading = false); 
    },
    seleccionaDocumento(movimiento) {
      if (movimiento > 0) {
        this.llaveActual+=1;
        if (this.llaveActual >= this.item_totales) {
          this.llaveActual=0;
        }
      } else if (movimiento < 0) {
        this.llaveActual-=1;
        if (this.llaveActual < 0) {
          this.llaveActual=this.item_totales-1;
        }
      }
      this.indicador = " "+(this.llaveActual + 1 )+"/"+ this.item_totales;
      this.estadolote= this.documentos[this.llaveActual].estadolote;
      if (this.estadolote == "ACTIVO") {
        this.boton_etiqueta="Rechazar";
        this.boton_disabled=false;
        this.descripcion_guardar="Motivo de rechazo:";
      } else if (this.estadolote == "RECHAZADO") {
        this.boton_etiqueta="Activar";
        this.boton_disabled=false;
        this.descripcion_guardar="Motivo de activar:";
      } else {
        this.boton_etiqueta="Rechazar";
        this.boton_disabled=true;
      }
        this.id_actual = this.documentos[this.llaveActual].id;
        this.fileName = this.documentos[this.llaveActual]?.nombre_archivo;
    },
    cambiarEstado() {

      var paquete = this.documentos[this.llaveActual];
      console.log("Cambiando estados");
      console.log(paquete);
      var purl = "Paquete/cambiar_estado";
      purl += "?paq_id=" +  paquete.id;
      purl += "&cliente_id=" +  paquete.clienteId;      
      purl += "&mensaje='"+this.descripcion+"'";

      
           
      let getdoc = axios.post(purl,{} , { 'headers': this.$store.state.user.headers })
      return getdoc.then(res => {
        console.log(res);
        this.elementos = res.data.total;
      })
      .catch(err => { 
          if (err.response) { console.log(err.response.data + " " +err.response.status)  } 
          else if (err.request) { console.log(err.request)  } 
          else  { console.log(err.message )}        
      })
      .finally(() => {this.loading = false; this.dialogo_rechazo=false;this.LoteDetalle(paquete.id);}   ); 
    },
  }
};
